import React from 'react';
import { Poppins } from 'src/common';
import { Scope } from 'src/components/formComposed/WorkspaceVariablesForm/types';
import styled from 'styled-components';
import CheckBox from 'src/components/form/CheckBox';

const Div = styled.div`
  .vw-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &__checks {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      grid-gap: 20px;
      margin-right: 30px;
    }
    &__avo-check {
      display: flex;
      align-items: center;
      grid-gap: 10px;
      cursor: pointer;
      user-select: none;
    }
  }
`;

interface HeadProps {
  scope: Scope;
  setShowAssessmentVarOnly: (show: boolean) => void;
  setHideEmptyVariables: (hide: boolean) => void;
  showAssessmentVarOnly: boolean;
  hideEmptyVariables: boolean;
  showHideEmptyVariables: boolean;
}

export const Head: React.FC<HeadProps> = ({
  scope,
  setShowAssessmentVarOnly,
  setHideEmptyVariables,
  showAssessmentVarOnly,
  hideEmptyVariables,
  showHideEmptyVariables,
}) => {
  return (
    <Div className="h-padding">
      <div className="vw-head">
        <Poppins className="m-title" px={28}>
          {scope.type === 'assessment' ? 'Assessment' : 'Workspace'} Variables
        </Poppins>
        <div className="vw-head__checks">
          {scope.type === 'assessment' && (
            <div
              className="vw-head__avo-check"
              onClick={() => setShowAssessmentVarOnly(!showAssessmentVarOnly)}
              data-cy="show-assessment-variables-only"
            >
              <Poppins color="cflowerBlue" px={14} weight={500}>
                Show assessment variables only
              </Poppins>
              <CheckBox small isChecked={showAssessmentVarOnly} />
            </div>
          )}
          {showHideEmptyVariables && (
            <div
              className="vw-head__avo-check"
              onClick={() => setHideEmptyVariables(!hideEmptyVariables)}
              data-cy="hide-empty-variables"
            >
              <Poppins color="cflowerBlue" px={14} weight={500}>
                Hide empty variables
              </Poppins>
              <CheckBox small isChecked={hideEmptyVariables} />
            </div>
          )}
        </div>
      </div>
    </Div>
  );
};
